import React, { useEffect, useState } from 'react';
import Chart from './charts'
import Typography from "@material-ui/core/Typography";
import { Table, TableCell, TableRow, Grid } from "@material-ui/core";
import { CustomSeparator, InputRow, Loader } from "./index";
import { chartTypes, dashboardReportYearOptions, monthNames, serviceCategory, servicesTypes } from "../environment";
import { commaSeparateValue, getUserDataFromLocalStorage } from '../services/utils'
import { helpHandler } from "../store/actions";
import './styles.css'
import { useDispatch } from "react-redux";
import { dashboardPage } from "../services/userManual";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';




// const helpData = [
//   { revenue: 'this is revenue of cp-rr this this is revenue of cp-rr this this is revenue of cp-rr this this is revenue of cp-rr this p' },
// ]



function Dashboard(props) {
   
  const { dashboard, servicesList, reportYear, setReportYear } = props;
  const [data, setData] = useState();
  const [displayData, setDisplayData] = useState();
  const [totalSum, setTotalSum] = useState(0);
  const [ddServices, setDdServices] = useState();
  let userData = getUserDataFromLocalStorage();
  let role = userData.role

  const dispatch = useDispatch();
  let totalRowSum = 0;

  const helpClick = () => {
    dispatch(helpHandler({ open: true, data: dashboardPage }))
  }
  // const userServices = ''
  useEffect(() => {
    let userServices = '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23'
    // let userData = getUserDataFromLocalStorage();
    if (userData !== "") {
      if (userData?.services) {
        userServices = userData?.services
      }
    }
    const userService = userServices ? userServices.split(',') : []

    const servicesArray = []
    let servicesLen = servicesList.length
    let allServices = []
    let servicesWithValue = []
    for (let i = 0; i < servicesLen; i++) {
      servicesWithValue.push({ label: servicesList[i].title, value: servicesList[i].id })
      allServices.push(servicesList[i].title)
      for (let j = 0; j < userService.length; j++) {
        if (servicesList[i].id === userService[j]) {
          servicesArray.push(servicesList[i].title)
        }
      }
    }

    let servicesLength = servicesList.length
    let chartServiceList = []
    let servicesWithValues = []
    for (let i = 0; i < servicesLength; i++) {
      servicesWithValues.push({ label: servicesList[i].title, value: servicesList[i].id })
      chartServiceList.push(servicesList[i].title)
    }
    // const chartServiceList = []
    // for (let i = 0; i < userService.length; i++) {
    //   chartServiceList.push(allServices[userService[i] -1])
    //   console.log("serv",(allServices[userService[i]-1 ]));
    // }

    const data = [['Month', ...chartServiceList]]
    if (dashboard) {
      for (const [key, value] of Object.entries(dashboard.result || [])) {
        let newKey = monthNames[key]
        let valuesArray = [newKey]
        let valuesService = []
        let listService = []
        var pre = 0
        for (let i = 0; i < chartServiceList.length; i++) {
          let service_id = i + 1;
          var val = 0
          if (value[i] && value[i]?.service_id === service_id) {
            val = parseInt(value[i].grossrevenue);
            pre = i + 1
          } else if (value[pre] && value[pre]?.service_id === service_id) {
            val = parseInt(value[pre].grossrevenue);
            pre++;
          }
          valuesArray.push(val);
        }
        data.push(valuesArray)

      }

      let len = data.length || 0
      let displayData = []
      for (let i = 0; i < data[0].length; i++) {
        let obj = []
        for (let j = 0; j < len; j++) {
          let val = data[j][i];
          if (!isNaN(val)) {
            val = commaSeparateValue(val)
          }
          obj.push(val)
        }
        displayData.push(obj)
      }
      const userDummyServices = [];
      const userServicesArray = []
      for (let i = 0; i < userService.length; i++) {
        userDummyServices.push(allServices[userService[i] - 1])
        let obj = {
          label: servicesWithValue[userService[i] - 1].label,
          value: servicesWithValue[userService[i] - 1].value
        }
        userServicesArray.push(obj)
      }

      let serviceCatArray = serviceCategory;
      if (role =='3' && userServicesArray) { /** Filter service category array according to cp services assigned to him */
        let pakServiceArray = [];
        let intServiceArray = [];
        pakServiceArray = userServicesArray.filter((item) => item.value < 11)
        intServiceArray = userServicesArray.filter((item) => item.value > 10)
        if (pakServiceArray && !intServiceArray.length)
          serviceCatArray = serviceCatArray.filter((item) => item.value == 0)
        else if(intServiceArray && !pakServiceArray.length)
          serviceCatArray = serviceCatArray.filter((item) => item.value == 1)
      }
        
      props.setUserServicesList(userServicesArray)// set user services in redux state
      props.setCategoryList(serviceCatArray)// set services categories in redux state
      /** set user service in service type dropdown */
      const userPlatforms = ['All', ...userDummyServices]
      // console.log(userPlatforms);
      setDdServices(servicesTypes.filter((item) => userPlatforms.includes(item.value)))
      
   
      const newDisData = []
      newDisData.push(displayData[0])
      // console.log(displayData[0].length);
      let newRow = []
      // var count = 0
      for (let i = 1; i < displayData.length - 1; i++) {
        // count = 0;
        if (displayData[i] !== undefined) {
          if (userDummyServices.includes(displayData[i][0])) {
            newDisData.push(displayData[i]);
          }
          else continue;
        }
        else break;

        /** Logic by sumair */
        // for (const [key, value] of Object.entries(displayData[i] || [])) {
        //   if (count === 0) {
        //     count++;
        //     if (userDummyServices.includes(value)) {
        //       newRow.push(value)
        //     } else {
        //       break;
        //     }
        //   } else {
        //     newRow.push(value)
        //   }
        // } 
        // if (newRow.length) {
        //   newDisData.push(newRow)
        //   console.log('outer loop', newDisData);
        // }
      }
      displayData = [...newDisData]
      // displayData = [...displayData]
      // console.log(displayData);
      // add total revenue of each column in data array
      let colSumArray = ['Total']
      let rows = displayData.length
      let cols = displayData[0].length
      let colSum = 0
      for (let i = 1; i < cols; i++) {
        colSum = 0
        for (let j = 0; j < rows; j++) {
          let val = JSON.parse(JSON.stringify(displayData[j][i]).replaceAll(",", ''))
          val = parseInt(val)
          if (val) {
            colSum += val
          }
        }
        colSumArray.push('PKR ' + commaSeparateValue(colSum));
      }
      displayData.push(colSumArray)
      

      /** For user services data in charts */
      let sortedData = [];
      for (let i = 0; i < userDummyServices.length; i++) {
        const index = data[0].findIndex(x => x == userDummyServices[i]);
        if (index != -1) {
          for (let j = 0; j < data.length; j++) {
            if (i == 0)
              sortedData.push([data[j][0], data[j][index]]);
            else
              sortedData[j].push(data[j][index]);
          }
        }
        else {
          sortedData.push(data);
          break;
        }
      }
      
      // setData(data)
        setData(sortedData)
      // console.log(sortedData);
      setDisplayData(displayData)
      let rSum = 0;
      for (let i = 0; i < displayData.length; i++) {
        rSum = 0;
        for (let j = 0; j < displayData[i].length; j++) {
          let val = JSON.parse(JSON.stringify(displayData[i][j]).replaceAll(",", ''))
          val = parseInt(val)
          if (val) {
            rSum += val;
          }
        }
        totalRowSum += rSum;
      }
      setTotalSum(totalRowSum);
    }
  },[dashboard])
    
    const [count, setCount] = useState(1)
  const itemClick = (obj, index) => {
    let arr = [...data]
    let newAry = [...arr.splice(0, index), ...arr.splice(index + 1, arr.length)]
    // let newAry = data.filter(ob => ob.index != obj.index)
    newAry.splice(count, 0, obj)
  }
  const [breadCrumbsList, setBreadCrumbsList] = React.useState([
    { text: 'Dashboard', url: '' }, { text: "Reports", url: '' },
  ]);
  const [chartType, setChartType] = useState('ColumnChart')
  const [ServicesType, setServicesType] = useState('All')
  const onChangeChartType = (value, key) => {
    if (key === 'reportYear') {
      setReportYear(value)
    } else if (key === 'chartType') {
      setChartType(value)
    }
    else if (key === 'ServicesType') {
      setServicesType(value)                                                                            
    }
  }
  return (
    <div className="driver-main-page">
      <CustomSeparator
        breadCrumbsList={breadCrumbsList}
        {...props}
        setBreadCrumbsList={setBreadCrumbsList}
        helpHandler={helpClick}
      />
      <div class="hh-stick"></div>
      {role !== '6' ? <div>
        <div className="datatable-box " >
          <Grid container  >
            <div className='table-title-container display-flex full-width'>
              <Typography variant='h4' className='table-title'
              // onClick={() => {
              //   props.confirmationHandler({open: true, data: 'sumair'})
              // }}
              >Revenue Report </Typography>
              <div className='display-flex half-width justify-content-end  '>
                {/*<div style={{width: '30%'}}>*/}
                <form className='inputColor thme-inputcolor' style={{ marginRight: '0px', width: '70%', marginTop: '2%' }}>
                  <InputRow
                    types={[
                      { type: 'select', value: reportYear, id: 'reportYear', dropdownList: dashboardReportYearOptions, label: 'report year' },
                      { type: 'select', value: chartType, id: 'chartType', dropdownList: chartTypes, label: 'chart type' },
                      { type: 'select', value: ServicesType, id: 'ServicesType', dropdownList: ddServices, label: 'Services Type' },
                    ]}
                    onChangeInput={(value, key) => {
                      onChangeChartType(value, key)
                    }}
                    numOfInputPerRow={3}
                  />
                </form>
                {/*</div>*/}
              </div>
            </div>
          </Grid>
          {data ?
            <div className={'mt-10'}>
              <Chart data={data} chartType={chartType} ServicesType={ServicesType} />
            </div> : <Loader />}
        </div>
        <div className="datatable-box" >
          <div className='mb-20'>
            <Table className='my-custom-table ' >
              {
                (displayData || []).map((item, index) => {
                  let rowSum = 0;
                  let colSum = 0;
                  // console.log('item ', item)
                  // if (index > 0 && (item[0] === 'Month'||item[0] === 'Bajao')) {
                  if (true) {
                    return (<TableRow hover key={`data ${item + index}`}
                      className={`${index === 0 && 'text  '} pt-20 mt-20 mouse-pointer   `}>
                      {(item || []).map((celValue, i) => {
                        let c = JSON.parse(JSON.stringify(celValue).replaceAll(",", ''))
                        c = parseInt(c)
                        if (c) {
                          rowSum += c
                        }
                        if (!isNaN(item[index])) {
                          colSum += item[index]
                        }

                        if ((i === item.length - 1)) {
                          return (
                            <>
                              <TableCell key={`cell ${item + i}`}
                                className={`${(i === 0 || index === 0) && 'text-bold  '} ${((displayData.length - 1 === index)) && ' bg-light2 '}`}>
                                {celValue}
                              </TableCell>
                              <TableCell key={`cell${i}`}
                                className={`${(i === 0 || index === 0) && 'text-bold '} ${((displayData.length - 1 === index) && i === 12) && 'text-bold bg-light2 '}`}>
                                <span className='badge-tb'>
                                  {index === 0 ? 'Total' : (index < displayData.length - 1) ? 'PKR ' + commaSeparateValue(rowSum) : 'PKR ' + commaSeparateValue(totalSum)}
                                </span>
                              </TableCell>
                            </>
                          )
                        } else {
                          return (
                            <TableCell key={`cell${item + i}`}
                              className={`${((i === 0 || index === 0)) && 'text-bold'} 
                                        ${((displayData.length - 1 === index)) && ' bg-light2 text-bold'}`}>
                              {celValue}
                            </TableCell>
                          )
                        }
                      })}
                    </TableRow>
                    )
                  }
                  return (
                    <>
                    </>
                  )
                })
              }
            </Table>
          </div>
        </div>
      </div>
      :
      <div className="datatable-box">
        <div className='table-title-container display-flex full-width'>
          <Typography variant='h4' className='table-title'>Welcome! {userData?.name}
          </Typography>
        </div>
      </div>}
    </div>
  );
}

export default Dashboard;
